import React, { useState } from "react";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import "./Sidebar.scss";

function Sidebar() {
  const [open, setOpen] = useState(false);

  const links = [
    { label: "Home", href: "#Home" },
    { label: "Projects", href: "#project-details" },
    { label: "Experience", href: "#work-details" },
    { label: "Contact", href: "#contact-details" },
  ];

  const closeMenu = () => setOpen(false);

  return (
    <header className="site-nav">
      <a className="site-nav__brand" href="#Home" onClick={closeMenu} aria-label="Mihir Saini home">
        <span>MS</span>
      </a>

      <nav className={`site-nav__links ${open ? "site-nav__links--open" : ""}`} aria-label="Primary navigation">
        {links.map((link) => (
          <a key={link.href} href={link.href} onClick={closeMenu}>
            {link.label}
          </a>
        ))}
        <a className="site-nav__resume" href="/resume.pdf" download="Mihir Saini Resume.pdf" onClick={closeMenu}>
          Resume
        </a>
      </nav>

      <button
        className="site-nav__toggle"
        type="button"
        aria-label={open ? "Close navigation" : "Open navigation"}
        aria-expanded={open}
        onClick={() => setOpen((current) => !current)}
      >
        {open ? <CloseRoundedIcon /> : <MenuRoundedIcon />}
      </button>
    </header>
  );
}

export default Sidebar;
